module.exports = __webpack_public_path__ + "static/m_3-71912a3f50c52a612c124802875b7e57.png";